import React from "react";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
const ShopEmailTemplate = [
  [
    "Shop Email Template",
"/admin/shop-email-template",
    <ForwardToInboxIcon
      sx={{ fontSize: "2rem", ml: "0.3rem" }}
    ></ForwardToInboxIcon>,
  ],
];

export default ShopEmailTemplate;
